import React from 'react';
import styled from 'styled-components';
import colors from '@honeybook/hbui/dist/styles/colors';
import spacing from '@honeybook/hbui/dist/styles/spacing';
import HBButton from '@honeybook/hbui/dist/components/HBButton/HBButton';
import { useTranslation } from 'react-i18next';
import { NAMESPACES } from '~/i18n/namespaces';
import { MustIncludeOneOfBasicTestIdProps } from '@honeybook/hbui/dist/components/common/internal/test-id.types';
import { TTemplatePanel } from '~/components/Templates/types/templates.types';

interface Props {
    type: string;
    activeFlowPanel?: TTemplatePanel | string;
}

const TemplateSelectEmptyState = ({
    type,
    activeFlowPanel,
    ...testIds
}: Props & MustIncludeOneOfBasicTestIdProps) => {
    const handleClick = () => {
        // console.log('handleClick');
    };

    const { t } = useTranslation(NAMESPACES.AUTOMATIONS, {
        keyPrefix: 'empty_state'
    });

    return (
        <>
            <EmptyTemplateText>
                {activeFlowPanel === 'Shared'
                    ? t('shared.text')
                    : t('empty_template_text', { type: type })}
            </EmptyTemplateText>

            <ButtonWrapper>
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="/app/templates"
                >
                    <HBButton
                        {...testIds}
                        onClick={handleClick}
                        size="xs"
                        buttonTheme="secondary-solid-secondary"
                    >
                        {t('create_template_button')}
                    </HBButton>
                </a>
            </ButtonWrapper>
        </>
    );
};

const EmptyTemplateText = styled.p`
    padding: ${spacing[16]};
    text-align: center;
    color: ${colors.neutral700};
    white-space: pre-line;
`;

const ButtonWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export default TemplateSelectEmptyState;
